import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=6bd9154b&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=6bd9154b&prod&scoped=true&lang=css"
import style1 from "./ChatMessage.vue?vue&type=style&index=1&id=6bd9154b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9154b",
  null
  
)

export default component.exports